import Component from '../inherited/Component'

let hcSticky = null

export default class VideoControls extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._video = this._elem.querySelector('video')
    this._buttonPlayPause = this._elem.querySelector('.button-play-pause')
  }

  mount () {
    this._buttonPlayPause.addEventListener('click', e => {
      this._togglePlay()
    })
  }

  _togglePlay () {
    if (this._buttonPlayPause.classList.contains('playing')) {
      this._video.pause()
      this._buttonPlayPause.classList.remove('playing')
    } else {
      this._video.play()
      this._buttonPlayPause.classList.add('playing')
    }
  }
}